// One lazy pdf.js for the whole app. The worker is a Vite asset URL; the wasm
// decoders (JPEG 2000 in the office blanks' logo) live in public/pdfjs, so
// callers pass wasmUrl: "/pdfjs/" to getDocument.
let pdfjsPromise = null;
export function loadPdfjs() {
  if (!pdfjsPromise) {
    pdfjsPromise = import("pdfjs-dist").then((mod) => {
      mod.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();
      return mod;
    }).catch((err) => { pdfjsPromise = null; throw err; });
  }
  return pdfjsPromise;
}
export const PDFJS_WASM_URL = "/pdfjs/";
